import { deleteCookie, getCookie, setCookie } from './cookieService';

const TOKEN_KEY_NAME = 'token';
const REFRESH_TOKEN_KEY_NAME = 'refresh_token';
const TOKEN_EXPIRATION_KEY_NAME = 'tokenExpiresAt';

const PROJECT_ID_KEY_NAME = 'project-id';

export function isUserAuthenticated() {
  return !!getToken();
}

export function setToken(token, expiresIn, refreshToken) {
  const expiresAt = Date.now() + expiresIn * 1000;
  setCookie(TOKEN_KEY_NAME, token, { path: '/', 'max-age': expiresIn });
  setCookie(REFRESH_TOKEN_KEY_NAME, refreshToken, { path: '/' });
  setCookie(TOKEN_EXPIRATION_KEY_NAME, expiresAt, { path: '/' });
}

export function getToken() {
  const token = getCookie(TOKEN_KEY_NAME);
  const expiresAt = getCookie(TOKEN_EXPIRATION_KEY_NAME);

  if (token && expiresAt) {
    const currentTime = Date.now();
    if (currentTime >= expiresAt - 60 * 1000) {
      tokenRefresh(getRefreshToken());
    }
  }

  return token;
}

export function getActiveProjectId() {
  const value = getCookie(PROJECT_ID_KEY_NAME);

  if (!value || value === 'null' || value === 'undefined') return '';

  return value;
}

export function setActiveProjectId(activeProjectId) {
  setCookie(PROJECT_ID_KEY_NAME, activeProjectId, { path: '/' });
}

export function getRefreshToken() {
  return getCookie(REFRESH_TOKEN_KEY_NAME);
}

export function clearAccessToken() {
  deleteCookie(TOKEN_KEY_NAME);
  deleteCookie(REFRESH_TOKEN_KEY_NAME);
}

export async function authenticate(url, tenant, username, password) {
  const response = await fetch(`${url}/users/token/obtain`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-tenant-id': tenant,
    },
    body: JSON.stringify({ username, password }),
  });
  const data = await response.json();
  if (response.ok) {
    return {
      token: data.id_token,
      refreshToken: data.refresh_token,
      expiresIn: data.expires_in,
    };
  }
  return {
    errorMessage: 'Unable to log in with provided credentials',
  };
}

export async function tokenRefresh(url, tenant, refreshToken) {
  const response = await fetch(`${url}/users/token/refresh`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-tenant-id': tenant,
    },
    body: JSON.stringify({ refresh_token: refreshToken }),
  });
  const data = await response.json();
  if (response.ok) {
    return {
      token: data.id_token,
      refreshToken: data.refresh_token,
      expiresIn: data.expires_in,
    };
  }
  return { success: false, message: data.error || 'Failed to refresh token.' };
}

export async function sendVerificationCode(url, tenant, username) {
  const response = await fetch(`${url}/users/password-reset-code`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-tenant-id': tenant,
    },
    body: JSON.stringify({ username }),
  });

  const data = await response.json();
  if (response.ok) {
    return { success: true, message: data.message };
  }
  return { success: false, message: data.error || 'Failed to send code.' };
}

export async function resetPassword(url, tenant, username, code, password) {
  const response = await fetch(`${url}/users/password-reset`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-tenant-id': tenant,
    },
    body: JSON.stringify({ username, code, password }),
  });

  const data = await response.json();
  if (response.ok) {
    return { success: true, message: data.message };
  }
  return { success: false, message: data.error || 'Failed to reset password.' };
}
